import { styled as r } from "@mui/material";
import i from "../../ui-lib/components/ApeironButton.js";
import n from "../assets/background-lp-button-active.png.js";
import p from "../assets/background-lp-button-inactive.png.js";
import { jsx as s } from "react/jsx-runtime";
const u = r(i)`
  ${(t) => t.theme.breakpoints.up("res768")} {
    height: 60px;
    min-width: 400px;

    .Custom-Left,
    .Custom-Right {
      width: 30px;
    }

    .Custom-Middle {
      background-size: 116% 100%;
      left: 30px;
      width: calc(100% - 60px);
    }
  }

  ${(t) => t.theme.breakpoints.down("res768")} {
    min-width: 300px;
  }

  :disabled {
    filter: saturate(200%);
    opacity: 0.6;

    .Custom-Button-Background {
      background-image: url(${`"${p}"`});
    }
  }

  .Custom-Button-Content {
    color: #ffffffdd;
    font-size: 18px;
    font-weight: 300;
    letter-spacing: 0.5px;
    text-transform: uppercase;
  }

  .Custom-Button-Background {
    background-image: url(${`"${n}"`});
  }
`, l = (t) => {
  const {
    children: o,
    ...e
  } = t;
  return /* @__PURE__ */ s(u, {
    ...e,
    children: o
  });
};
export {
  l as default
};
//# sourceMappingURL=VipLpButton.js.map
